/**
 * @flow
 * @relayHash cb88a16110fde1ae40f88f70d3620792
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ActivateProductInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type ActivateProductMutationVariables = {|
  input: ActivateProductInput
|};
export type ActivateProductMutationResponse = {|
  +activateProduct: ?{|
    +updatedProduct: ?{|
      +id: string,
      +isActive: boolean,
    |}
  |}
|};
export type ActivateProductMutation = {|
  variables: ActivateProductMutationVariables,
  response: ActivateProductMutationResponse,
|};
*/


/*
mutation ActivateProductMutation(
  $input: ActivateProductInput!
) {
  activateProduct(input: $input) {
    updatedProduct {
      id
      isActive
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ActivateProductInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "activateProduct",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ActivateProductPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updatedProduct",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isActive",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ActivateProductMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ActivateProductMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ActivateProductMutation",
    "id": null,
    "text": "mutation ActivateProductMutation(\n  $input: ActivateProductInput!\n) {\n  activateProduct(input: $input) {\n    updatedProduct {\n      id\n      isActive\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ea2be6dbe72079bc7d9a8edb4ba4f519';
module.exports = node;
